// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2ZZHH","footer":"ModalUpdate_footer__1NF5x"};